import React from 'react'
import { getIcons } from '../../Constant/Constant'

const SettingModel = ({isOpen , close}) => {
    const icon = getIcons()


    if (!isOpen) return null
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div className="bg-white flex flex-col gap-6 rounded-lg p-6 w-full max-w-2xl relative">
      <div className="flex items-center justify-between bg-slate-100  px-3 py-4 rounded-md ">
        <div className="text-lg font-medium text-customGreen">
        Redirecting to Facebook
        </div>
        <button
          onClick={close}
          className=" text-2xl bg-white rounded-full w-10 h-10  text-red-500"
          >
          &times;
        </button>
      </div>
<div>
Click on <span className='font-semibold'>‘Edit Setting’</span> when prompted to select the Facebook page you want to connect
</div>
       <div className='flex items-center justify-center'>
       <img src={icon.SettingFaceBookImage} className='w-[430px]'/>
       </div>

        <button className='bg-customGreen text-center text-white font-medium py-2 rounded-lg'>
            Okay
        </button>

        </div>
      
    </div>
  )
}

export default SettingModel
